export default __webpack_public_path__ + "static/media/mobileApp.c18e0ae8.svg";